import { PaymentErrorEnum } from "../apis";

export enum PaymentPurchaseErrorEnum {
  RedemptionFailure = "RedemptionFailure",
  CardDeclined = "CardDeclined",
}

export enum GeneralPurchaseErrorEnum {
  NoAvailability = "NoAvailability",
  FraudAutoReject = "FraudAutoReject",
  InvalidSession = "InvalidSession",
  InActivity = "Inactivity",
  LikelyFraud = "LikelyFraud",
  AuthError = "AuthError",
  CartValidationError = "CartValidationError",
  ExpiredFulfillToken = "ExpiredFulfillToken",
  ExpiredQuoteToken = "ExpiredQuoteToken",
  ErrorCode = "ErrorCode",
}

export interface UncategorizedPurchaseError {
  code: PaymentErrorEnum;
  title: string;
  subtitle: string;
}

export type PurchaseError =
  | PaymentPurchaseErrorEnum
  | GeneralPurchaseErrorEnum
  | UncategorizedPurchaseError;
